import { limitedBranchWindhailCoverage } from '@ourbranch/lookups';
import { tooltipHoverTexts } from 'core/helpers/constants';

// Where to send staff for wind/hail coverage when Branch excludes it, by state.
// Each state in limitedBranchWindhailCoverage has its own residual market:
// AL -> AIUA, GA -> GUA (gobranch/branch#36313).
const windHailExclusionTooltips = {
  AL: 'Branch does not cover for wind or hail damage in this zipcode. This coverage can be purchased through AIUA (https://aiua.org) as an additional purchase.',
  GA: `Branch does not cover wind or hail damage at this address due to its proximity to the coastline. This coverage can be purchased through the ${limitedBranchWindhailCoverage.GA.residualMarket} (${limitedBranchWindhailCoverage.GA.link}) as an additional purchase.`
};

export const getWindHailTooltip = ({ state, windHailExclusion }) =>
  (limitedBranchWindhailCoverage[state] && windHailExclusion && windHailExclusionTooltips[state]) ||
  tooltipHoverTexts.windHail;
